import PropTypes from 'prop-types';
import { useMemo } from 'react';

import { alpha, ThemeProvider, createTheme, useTheme, lighten, darken } from '@mui/material/styles';

import useSettings from '../hooks/useSettings';
import useBranding from '../hooks/useBranding';
//
import componentsOverride from '../theme/overrides';



ThemeColorPresets.propTypes = {
  children: PropTypes.node,
};

export default function ThemeColorPresets({ children }) {
  const defaultTheme = useTheme();
  const { setColor } = useSettings();
  const branding = useBranding();

  // The brand primary colour (set in admin) overrides the preset colour.
  // Lighter/darker shades are derived from the single brand hex.
  const primary = useMemo(() => {
    const color = branding.primary_color;
    if (!color) return setColor;
    try {
      return {
        name: 'brand',
        lighter: lighten(color, 0.8),
        light: lighten(color, 0.4),
        main: color,
        dark: darken(color, 0.2),
        darker: darken(color, 0.4),
        contrastText: '#fff',
      };
    } catch (e) {
      return setColor;
    }
  }, [branding.primary_color, setColor]);

  const themeOptions = useMemo(
    () => ({
      ...defaultTheme,
      palette: {
        ...defaultTheme.palette,
        primary,
      },
      customShadows: {
        ...defaultTheme.customShadows,
        primary: `0 8px 16px 0 ${alpha(primary.main, 0.24)}`,
      },
    }),
    [primary, defaultTheme]
  );

  const theme = createTheme(themeOptions);
  theme.components = componentsOverride(theme);

  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
